import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Cookies, useCookies } from "react-cookie";
import AddChannelPage from "../Channels/AddChannel";
import ViewChannelsPage from "../Channels/ViewChannelsPage";
import AddProjectPage from "../Projects/AddProject";
import ViewProjectsPage from "../Projects/ViewProjects";
import AddActionPage from "../Actions/AddAction";
import ViewActionsPage from "../Actions/ViewActions";
import ViewUsersPage from "../Users/ViewUsers";
import ViewLeadsPage from "../Leads/ViewLeads";
import AddSingleLeadPage from "../Leads/AddSingleLead";
import ViewCompaniesPage from "../Companies/ViewCompanies";
import AddCompanyPage from "../Companies/AddCompany";
import ImportLeadsPage from "../Leads/ImportLeads";
import Logo from "../../assets/logo.png";

const Home = (props) => {
  const cookie = new Cookies();
  const [cookies] = useCookies(["role", "super"]);
  const [freelancer, setFreelancer] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("");
  const [activeSubSubTab, setActiveSubSubTab] = useState("");
  const [listTap, setListTap] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const teamLeaderTabs = [
    {
      name: "Leads",
      sub_page: [
        {
          title: "Import Leads",
          sub: [],
        },
        {
          title: "Add Single Lead",
          sub: [],
        },
        {
          title: "All Leads",
          sub: [
            "Fresh Leads",
            "Assign Leads",
            "My Assign Leads",
            "Delay Leads",
            "Follow Leads",
            "Done Leads",
            "No Follow Leads",
          ],
        },
      ],
    },
    {
      name: "Settings",
      sub_page: [
        {
          title: "Channels",
          sub: ["View Channels", "Add Channel"],
        },
        {
          title: "Projects",
          sub: ["View Projects", "Add Project"],
        },
        {
          title: "Actions",
          sub: ["View Actions", "Add Action"],
        },
      ],
    },
    {
      name: "Users",
      sub_page: [{ title: "Users", sub: [] }],
    },
    {
      name: "Logout",
      sub_page: [],
    },
  ];

  const superCompanyTabs = [
    {
      name: "Leads",
      sub_page: [
        {
          title: "Import Leads",
          sub: [],
        },
        {
          title: "Add Single Lead",
          sub: [],
        },
        {
          title: "All Leads",
          sub: [
            "Users Leads",
            "Companies Leads",
            "Fresh Leads",
            "Assign Leads",
            "Delay Leads",
            "Follow Leads",
            "Done Leads",
            "No Follow Leads",
          ],
        },
      ],
    },
    {
      name: "Settings",
      sub_page: [
        {
          title: "Channels",
          sub: ["View Channels", "Add Channel"],
        },
        {
          title: "Projects",
          sub: ["View Projects", "Add Project"],
        },
        {
          title: "Actions",
          sub: ["View Actions", "Add Action"],
        },
      ],
    },
    {
      name: "Users",
      sub_page: [{ title: "Users", sub: [] }],
    },
    {
      name: "Companies",
      sub_page: [
        { title: "View Companies", sub: [] },
        { title: "Add Company", sub: [] },
      ],
    },
    {
      name: "Logout",
      sub_page: [],
    },
  ];

  const companyTabs = [
    {
      name: "Leads",
      sub_page: [
        {
          title: "Import Leads",
          sub: [],
        },
        {
          title: "Add Single Lead",
          sub: [],
        },
        {
          title: "All Leads",
          sub: [
            "Users Leads",
            "Fresh Leads",
            "Assign Leads",
            "Delay Leads",
            "Follow Leads",
            "Done Leads",
            "No Follow Leads",
          ],
        },
      ],
    },
    {
      name: "Settings",
      sub_page: [
        {
          title: "Channels",
          sub: ["View Channels", "Add Channel"],
        },
        {
          title: "Projects",
          sub: ["View Projects", "Add Project"],
        },
        {
          title: "Actions",
          sub: ["View Actions", "Add Action"],
        },
      ],
    },
    {
      name: "Users",
      sub_page: [{ title: "Users", sub: [] }],
    },
    {
      name: "Logout",
      sub_page: [],
    },
  ];

  const freelancerTabs = [
    {
      name: "Leads",
      sub_page: [
        {
          title: "All Leads",
          sub: [
            "Fresh Leads",
            "Delay Leads",
            "Follow Leads",
            "Done Leads",
            "No Follow Leads",
          ],
        },
      ],
    },
    {
      name: "Settings",
      sub_page: [
        {
          title: "Actions",
          sub: ["View Actions", "Add Action"],
        },
      ],
    },
    {
      name: "Logout",
      sub_page: [],
    },
  ];

  const navigate = useNavigate();

  const [list, setList] = useState(null);

  useEffect(() => {
    const role = cookies.role;
    const isSuper = cookies.super;

    if (role === "Team Leader") {
      setListTap(teamLeaderTabs);
    } else if (role === "Company") {
      if (isSuper) {
        setListTap(superCompanyTabs);
      } else {
        setListTap(companyTabs);
      }
    } else {
      setListTap(freelancerTabs);
      setFreelancer(true);
    }

    if (localStorage.getItem("page")) {
      setActiveTab(localStorage.getItem("page"));
    }
    if (localStorage.getItem("subpage")) {
      setActiveSubTab(localStorage.getItem("subpage"));
    }
    if (localStorage.getItem("subsubpage")) {
      setActiveSubSubTab(localStorage.getItem("subsubpage"));
    }
  }, [cookies.role, cookies.super]);

  const changeToView = async (sub) => {
    setActiveSubSubTab(sub);
    localStorage.setItem("subsubpage", sub);
    window.location.reload();
  };

  const changeToViewCompanies = async () => {
    setActiveSubTab("View Companies");
    localStorage.setItem("subpage", "View Companies");
    setActiveSubSubTab("");
    localStorage.removeItem("subsubpage");
    window.location.reload();
  };

  const changeToViewAddLead = async () => {
    setActiveSubTab("All Leads");
    localStorage.setItem("subpage", "All Leads");
    setActiveSubSubTab("Fresh Leads");
    localStorage.setItem("subsubpage", "Fresh Leads");
    window.location.reload();
  };

  return (
    <div className="dashboard-container">
      <button
        className="menu-toggle"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        ☰
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h2 style={{ width: "190px" }}>CRM</h2>
          <h3 style={{ width: "190px" }}>Role: {cookie.get("role")}</h3>
        </div>

        <div className="tabs">
          {listTap.map((tab) => (
            <div key={tab.name} style={{ width: "100%" }}>
              <button
                className={`tab ${
                  activeTab === tab.name &&
                  activeSubTab === "" &&
                  activeSubSubTab === ""
                    ? "active"
                    : ""
                }`}
                style={{ width: "100%" }}
                onClick={() => {
                  if (tab.name === "Logout") {
                    navigate("/login", { replace: true });
                    localStorage.clear();
                    cookie.remove("crm");
                    cookie.remove("id");
                    cookie.remove("role");
                    cookie.remove("super");
                  } else {
                    setActiveSubTab("");
                    setActiveSubSubTab("");
                    localStorage.removeItem("subpage");
                    localStorage.removeItem("subsubpage");

                    if (tab.name !== activeTab) {
                      setActiveTab(tab.name);
                      localStorage.setItem("page", tab.name);
                    } else {
                      setActiveTab("");
                      localStorage.removeItem("page");
                    }
                  }
                }}
              >
                {tab.name}
              </button>

              {tab.name === activeTab && (
                <>
                  {tab.sub_page.map((page) => (
                    <div
                      key={page.title}
                      style={{ width: "100%", paddingLeft: "20px" }}
                    >
                      <button
                        className={`tab ${
                          activeSubTab === page.title && activeSubSubTab === ""
                            ? "active"
                            : ""
                        }`}
                        style={{
                          width: "90%",
                          paddingLeft: "20px",
                          color: "darkkhaki",
                        }}
                        onClick={() => {
                          setActiveSubSubTab("");
                          localStorage.removeItem("subsubpage");

                          if (page.title === activeSubTab) {
                            setActiveSubTab("");
                          } else {
                            setActiveSubTab(page.title);
                            localStorage.setItem("subpage", page.title);
                            if (page.sub.length === 0) {
                              setIsSidebarOpen(false);
                            }
                          }
                        }}
                      >
                        {page.title}
                      </button>

                      {page.title === activeSubTab && (
                        <>
                          {page.sub.map((sub) => (
                            <div
                              key={sub}
                              style={{
                                width: "100%",
                                paddingLeft: "20px",
                              }}
                            >
                              <button
                                className={`tab ${
                                  activeSubSubTab === sub ? "active" : ""
                                }`}
                                style={{
                                  width: "100%",
                                  paddingLeft: "20px",
                                  color: "aquamarine",
                                }}
                                onClick={() => {
                                  localStorage.removeItem("subsubpage");
                                  if (sub === activeSubSubTab) {
                                    setActiveSubSubTab("");
                                  } else {
                                    setActiveSubSubTab(sub);
                                    localStorage.setItem("subsubpage", sub);
                                    setIsSidebarOpen(false);
                                  }
                                }}
                              >
                                {sub}
                              </button>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Overlay */}
      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="main-content">
        <div className="content-header">
          <h1>
            {activeSubSubTab === ""
              ? activeSubTab === ""
                ? activeTab === ""
                  ? "CRM"
                  : activeTab
                : activeSubTab
              : activeSubSubTab}
          </h1>
        </div>
        <div className={`content-body`}>
          {activeSubTab !== "Import Leads" &&
            activeSubTab !== "Add Single Lead" &&
            activeSubTab !== "All Leads" &&
            activeSubTab !== "Users" &&
            activeSubTab !== "View Companies" &&
            activeSubTab !== "Add Company" &&
            activeSubSubTab === "" && (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <img src={Logo} alt="Logo" height="400px" />
              </div>
            )}
          {activeSubTab === "View Companies" && <ViewCompaniesPage />}
          {activeSubTab === "Import Leads" && <ImportLeadsPage />}
          {activeSubTab === "Add Company" && (
            <AddCompanyPage changeToViewCompanies={changeToViewCompanies} />
          )}
          {activeSubTab === "Add Single Lead" && (
            <AddSingleLeadPage changeToViewAddLead={changeToViewAddLead} />
          )}
          {activeSubTab === "All Leads" && activeSubSubTab === "" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="All"
              type="no"
            />
          )}
          {activeSubSubTab === "Companies Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Company"
              type="no"
            />
          )}
          {activeSubSubTab === "Users Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="User"
              type="no"
            />
          )}
          {activeSubSubTab === "Fresh Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Fresh"
              type="no"
              assign={false}
            />
          )}
          {activeSubSubTab === "Assign Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Fresh"
              type="no"
              assign={true}
            />
          )}
          {activeSubSubTab === "My Assign Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Fresh"
              type="no"
              isMe={true}
            />
          )}
          {activeSubSubTab === "Delay Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Delay"
              type="delay"
            />
          )}
          {activeSubSubTab === "Follow Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Follow"
              type="no"
            />
          )}
          {activeSubSubTab === "No Follow Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="No Follow"
              type="no"
            />
          )}
          {activeSubSubTab === "Done Leads" && (
            <ViewLeadsPage
              freelancer={freelancer}
              description="Done"
              type="no"
            />
          )}
          {activeSubSubTab === "Add Channel" && (
            <AddChannelPage changeToView={changeToView} />
          )}
          {activeSubSubTab === "View Channels" && <ViewChannelsPage />}
          {activeSubSubTab === "Add Project" && (
            <AddProjectPage changeToView={changeToView} />
          )}
          {activeSubSubTab === "View Projects" && <ViewProjectsPage />}
          {activeSubSubTab === "Add Action" && (
            <AddActionPage changeToView={changeToView} />
          )}
          {activeSubSubTab === "View Actions" && <ViewActionsPage />}
          {activeSubTab === "Users" && <ViewUsersPage role="Users" />}
        </div>
      </div>
    </div>
  );
};

export default Home;
